var MongoQuery = require('../MongoQuery');
var deepCopy = require("derby/node_modules/racer/lib/util").deepCopy;
var Search = require('../data-objects/Search');
//var indexBy = require('../util/indexBy');
//polyfills for the Date object
require('date-utils');

module.exports = SearchSongsUseCase;

/**
 * @param {Model} model		Racer model
 * @param {object} searchParams   JSON object of search conditions
 */
function SearchSongsUseCase(model, searchParams) {
	//used to make the ready() callback work - all method calls to this object should be inside a ready() callback
	this._isReady = false;
	this.model = model;
	this.searchParams = deepCopy(searchParams); //we make some changes to arrays while building the query so make a copy first
	this.userIsSubscribed = model.get('_session.user.isSubscribed');
	this.sortOrder = 'sortTitle'; //default sort order
	this.composerConditions = [];
	this.loadFeaturedComposers();
}

SearchSongsUseCase.prototype = {
	constructor: SearchSongsUseCase
	
  , loadFeaturedComposers: function() {
		var featuredComposers = this.model.get('_global.featuredComposers');
		if (featuredComposers == undefined) {
			console.error('Featured composers not loaded. Load them into _global.featuredComposers first.');
			this.featuredComposers = [];
		}
		
		//Check for any data format errors (ignore any null values).
		//The featuredComposers should already be in the correct format, but since it would crash the server if not,
		//we double-check here.
		var validFeaturedComposers = [];
		featuredComposers.forEach(function(item) {
			if (item) validFeaturedComposers.push(item);
		});
		
		this.featuredComposers = validFeaturedComposers;
	}
	
	//get IDs of the featured composers of the month
  , getFeaturedComposerIds: function() {
		return this.featuredComposers.map(function(composer) {
			return composer.id;
		});
	}
	
	/**
	 * Build the main search query
	 * @returns {object} query conditions object
	 */
  , buildSearchQuery: function() {
		var query = this._buildBaseQueryWithoutComposerFilter();

		if (this.composerConditions.length) {		
			if (!query.$and) query.$and = [];
			query.$and = query.$and.concat(this.composerConditions);
		}
		query.setSortOrder(this.sortOrder);

		//console.log('main query:'); console.dir(query);

//		console.log('or conditions:');
//		console.log(query.$and[0].$or)
//		if (query.$and[1]) {
//			console.log(query.$and[1].$or)
//		}

		//console.log(JSON.stringify(query));)
		
		//Record the search request, for statistics
		this.model.add('searches', new Search({
			searchParams: this.searchParams,
			userId: this.model.get('_session.userId'),
			subscriptionId: this.model.get('_session.subscriptionId')
		}));
		
		return query;
	}

	/**
	 * For the free version we want to count how many results there would be with no composer filters,
	 * in order to advertise the number of songs in the full database.
	 * @returns {object} query conditions object
	 */
  , buildCountQueryWithoutComposerFilter: function() {
		var query = this._buildBaseQueryWithoutComposerFilter();

		//console.log('count query:'); console.dir(query);
        return {$count: true, $query: query.clone()};
	}

	/**
	 * @param {string} fieldNamesAndDirections
	 *      For multiple field names, separate with commas. Direction defaults to ascending.
	 *      For descending, add -1 after the field name, e.g. 'firstName -1'
	 */
  , setSortOrder: function(fieldNamesAndDirections) {
        this.sortOrder = fieldNamesAndDirections;
	}

	/**
     * @param {bool} rebuild   Whether to rebuild the query conditions rather than assume they're the same
     *                         as the last time this method was called
     */
  , _buildBaseQueryWithoutComposerFilter: function(rebuild) {
        if (!rebuild && this._baseQueryWithoutCompsoserFilter) {
            return this._baseQueryWithoutCompsoserFilter;
        }

		var model = this.model,
			search = this.searchParams,
			userIsSubscribed = this.userIsSubscribed;

		var query = new MongoQuery();

		//conditions to be joined with '$and'
		//(MongoDB requires by default that all specified conditions match, but in some cases we have multiple $or conditions
		//that need to be joined by $and [see below])
		var andConditions = [];

		//for the composer checkboxes in the free search, composerIds is already an array
		if (!Array.isArray(search.composerIds)) {
			search.composerIds = search.composerIds ? search.composerIds.split('|'): null;
		}
		search.lyricistIds = search.lyricistIds ? search.lyricistIds.split('|'): null;

		//Free searches can only search the featured composers of the month
		if (!userIsSubscribed) {
			var restrictToFeaturedComposers = true;
		
			//special case: results for holiday/seasonal tag are available on the free site
			//Nov-Jan
			if (search.tags && search.tags.indexOf('holiday/seasonal') != -1) {
				var m = new Date().getMonth();
				if (m >= 10 || m == 0) {
					restrictToFeaturedComposers = false;
				}
			}
			
			if (restrictToFeaturedComposers) {
				var featuredComposerIds = this.getFeaturedComposerIds();
				var validComposerIds = [];
				
				//TEMP
				//added temporarily for Chicago competition
				featuredComposerIds = featuredComposerIds.concat( model.get('_global.chicagoCompetitionComposers') );

				if (search.composerIds) {
					//check to make sure requested composer ID(s) are in the composers of the month
					search.composerIds.forEach(function(composerId) {
						//TODO make sure Array.prototype.indexOf shim is loaded for older browsers
						if (featuredComposerIds.indexOf(composerId) != -1) {
							validComposerIds.push(composerId);
						}
					});
				}

				//search all featured composers if no valid composer IDs provided
				if (validComposerIds.length==0) validComposerIds = featuredComposerIds;

				search.composerIds = validComposerIds;
			}
			else {
				//This is a bit of a hack (it would be better to do this in the route function),
				//but it's the simplest way to account for special cases like holiday/seasonal songs,
				//where we're showing results on the free site for songs that aren't necessarily by
				//featured composers.
				this.model.set('_page.showNumSongsSearchingAllComposers', false);
			}
		}

		var lyricistConditions = [];
		this._addComposerOrLyricistConditions('composer', this.composerConditions);
		this._addComposerOrLyricistConditions('lyricist', lyricistConditions);

		//age range, voice type, tempo, and popularity can optionally have multiple values selected,
		//so use $in to match any of them
		if (search.ageRanges) query.ageRanges = {$in: search.ageRanges};
		if (search.voiceTypes) query.voiceType = {$in: search.voiceTypes};
		//technically the plural of 'tempo' is 'tempi' but in the code we just refer to it as 'tempos'
		if (search.tempos) query.tempo = {$in: search.tempos};
		if (search.popularities) query.popularity = {$in: search.popularities};

		if (('isComic' in search)) query.isComic = search.isComic;

		//
		//Additional Song Details
		//
		if (search.songTitle) query.title = {$regex: search.songTitle.trim(), $options: 'i'};
		if (search.showTitle) {
			query.showTitle = {$regex: search.showTitle.trim(), $options: 'i'};
			//it doesn't make sense to include stand-alone songs (i.e. songs not attached to a show) when searching by show title
			query.isStandalone = {$in: [null, false]}; //check for either null/non-existent or false
		}

		//decade or year range
		var from, to;
		if (search.fromDecade) {
			from = search.fromDecade;
			to = search.toDecade;
		}
		else if (search.fromYear) {
			from = search.fromYear;
			to = search.toYear;
		}

		//TODO is this the desired behavior? e.g. if you only enter a "from" year it will search from that year forward, not only that year
		if (from || to) {
			query.yearWritten = {};
			if (from) from = parseInt(from);
			if (to) to = parseInt(to);

			//TODO
			//yearWritten is currently stored as a string in the DB; should be stored as an int
			//for now we just convert to string here.
			//
			//IMPORTANT!
			//auto-updating songList query parameters will need to be updated too (convert the string years to int years)

			if (from == to) query.yearWritten = from + ''; //TEMP WORKAROUND converting these to strings
			else {
				if (from) query.yearWritten.$gte = from + ''; //TEMP WORKAROUND converting these to strings
				if (to) query.yearWritten.$lte = to + '';
			}
		}

		['hasFemaleComposer', 'hasBIPOCComposer', 'hasFemaleLyricist', 'hasBIPOCLyricist'].forEach(function(field) {
			if (search[field])
				query[field] = search[field];
		});

		if (search.timeSignature) query.timeSignature = search.timeSignature;

		//accompanist difficulty searches always include the lower numbers as well
		if (search.accompanistDifficulty)
			query.accompanistDifficulty = {$lte: search.accompanistDifficulty};

		//for original key, we allow searching either for the key or more broadly for all songs
		//that are major or minor
		if (search.originalKey) {
			if (search.originalKey.pitch) query['originalKey.pitch'] = search.originalKey.pitch;
			if (search.originalKey.majorMinor) query['originalKey.majorMinor'] = search.originalKey.majorMinor;
		}

		//Tags
		if (search.tags) {
			var tags = search.tags.split(',');
			//the song must match all tags specified
			query.tags = {$all: tags};
		}

		//Voice Range
		var voiceRangeSearch = search.voiceRange;
		if (voiceRangeSearch) {
			var note;
			if (voiceRangeSearch.lowestNote) {
				note = voiceRangeSearch.lowestNote;
                query['voiceRange.lowestNote.midiNum'] = (note.exactMatch ? note.midiNum: {$gte: note.midiNum});
            }
            if (voiceRangeSearch.highestNote) {
                note = voiceRangeSearch.highestNote;
                query['voiceRange.highestNote.midiNum'] = (note.exactMatch ? note.midiNum: {$lte: note.midiNum});
            }
	    }
		
		//Founder's Pick (isRecommended)?
		if (search.isRecommended) {
			query.isRecommended = true;
		}

		//search for recently added songs
		if (search.dateSongCreated) {
			var minDateSongCreated = new Date();
			//use date-utils methods to subtract time
			minDateSongCreated.remove({days:search.dateSongCreated.numDays});
			query.dateCreated = {$gte: minDateSongCreated.getTime()};
		}
				
		//search for recently added shows
		if (search.dateShowCreated) {
			var minDateShowCreated = new Date();
			//use date-utils methods to subtract time
			minDateShowCreated.remove({days:search.dateShowCreated.numDays});
			query.dateShowCreated = {$gte: minDateShowCreated.getTime()};
		}

		//Add $and and $or conditions

		//The purpose of this method is as a helper to count how many results there would be with no composer filters,
		//so we only add the lyricistConditions here
		andConditions = andConditions.concat(lyricistConditions);

		//This is needed because we have more than one field that we're searching using '$or'
		if (andConditions.length)
			query.$and = andConditions;

		//cache the query conditions object
		this._baseQueryWithoutCompsoserFilter = query;
		return query;
    }

  , _addComposerOrLyricistConditions: function(composerOrLyricist, conditionsArray) {
        var search = this.searchParams;
		//search for a match of any of the specified composers/lyricists, using '$or'
		var orConditions = [];

		//Convert to MongoDB query
		//  Note: composers are stored as a hash in the DB, e.g.
		//  "composers": {
		//    "8004b3b0-f8bc-4a5f-a3f9-e8bda64e5149": {
		//      "firstName": "Barbara",
		//      "lastName": "Schottenfeld",
		//      "id": "8004b3b0-f8bc-4a5f-a3f9-e8bda64e5149"
		//    }
		var cOrLIds = search[composerOrLyricist + 'Ids'];

		if (cOrLIds) {
			var condition;
			cOrLIds.forEach(function(id) {
				condition = {};
				condition[composerOrLyricist+'s.'+id] = {$exists:true};
				orConditions.push(condition);
			});

			conditionsArray.push( {$or: orConditions} );
		}
	}

	//Featured composers of the month
  , /*async*/ getFeaturedComposers: function(cb) {
		var self = this;
		var model = this.model;
		//load the composers
		//(the featuredComposers array in the config collection only includes the composer IDs,
		//not the composers themselves)
		var query = model.query('composers', {'id': {'$in': self.getFeaturedComposerIds()}, $orderby: {lastName:1}});
		query.fetch(function(err) {
			if (err) return next(err);
			var composers = query.get();
			var customLabelsByComposerId = {};
			self.featuredComposers.forEach(function(item) {
				if (item.customLabel)
					customLabelsByComposerId[item.id] = item.customLabel;
			});
			
			//set the (display-only) label property on each composer
			composers.forEach(function(composer) {
				var label = customLabelsByComposerId[composer.id];
				if (!label) {
					label = composer.firstName + ' ' + composer.lastName;
				}
				composer.label = label;
			});
			
			cb(null, composers);		
		});
	}
};